<template>
  <div v-if="hasAnyData" class="future-content-needs">
    <!-- Coming Weeks Section -->
    <FutureContentSection
      v-if="props.nextCalendarGenSummary"
      :summary="props.nextCalendarGenSummary"
      :title="getDateRangeLabel(props.nextCalendarGenSummary)"
      :showTopicSummary="!props.hidePostGuidance"
      :showTitleAboveSection="true"
      :actionsShown="['customerUpload']"
      :customerId="props.customerId"
      :hideActions="props.hideActions"
      :defaultExpanded="props.defaultExpanded"
      :showDebug="props.showDebug"
      bucketKey="ComingWeeks"
      class="future-content-needs__section"
    >
      <template v-if="props.nextPostGenOnWeek" #header-extra>
        <div class="week-title-divider__subtitle" style="display: flex; align-items: center; gap: 4px">
          <span>Next posts will generate on {{ DayjsExtended(props.nextPostGenOnWeek).format("MMM Do") }}</span>
          <LinkWithIcon class="header-main__settings-link" tag="router-link" isDottedUnderline color="gray" :to="{ name: 'CalendarConfig', params: { customerId: props.customerId } }">
            <template #icon><IconEmbedded name="gear_2" :size="18" /></template>
          </LinkWithIcon>
        </div>
      </template>
    </FutureContentSection>

    <!-- Coming Months Section -->
    <FutureContentSection
      v-if="props.longTermCalendarGenSummary"
      :summary="props.longTermCalendarGenSummary"
      title="Following Months"
      :showTopicSummary="false"
      :showTitleAboveSection="true"
      :actionsShown="['communityUpload', 'creatorVisit', 'customerUpload']"
      :customerId="props.customerId"
      :hideActions="props.hideActions"
      :defaultExpanded="props.defaultExpanded"
      :showDebug="props.showDebug"
      bucketKey="ComingMonths"
      class="future-content-needs__section"
    />

    <!-- Footer note
    <p class="global-p future-content-needs__footer">Future posts may be delayed or skipped if we don't have enough relevant content.</p>-->
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { CalendarGenResultSummaryData } from "@contracts/contentCalendar";
import DayjsExtended from "@logic/DayjsExtended";
import FutureContentSection from "./FutureContentSection.vue";
import LinkWithIcon from "@components/LinkWithIcon.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";

const props = defineProps<{
  nextCalendarGenSummary: CalendarGenResultSummaryData | null;
  longTermCalendarGenSummary: CalendarGenResultSummaryData | null;
  customerId: string;
  nextPostGenOnWeek?: string;
  hideActions?: boolean;
  hidePostGuidance?: boolean;
  defaultExpanded?: boolean;
  showDebug?: boolean;
}>();

// Get date range label from summary data
function getDateRangeLabel(summary: CalendarGenResultSummaryData): string {
  // Update: Moved to just one for "coming weeks"
  return "Coming Weeks";
  /* 
  if (!summary?.startDate) return "Coming Weeks";

  const startDate = DayjsExtended(summary.startDate);
  const endDate = startDate.add(summary.weeksGenerated * 7 - 1, "day");

  // Format as "Dec 1st - 14th" or "Dec 28th - Jan 10th"
  if (startDate.month() === endDate.month()) {
    return `${startDate.format("MMM Do")} - ${endDate.format("Do")}`;
  } else {
    return `${startDate.format("MMM Do")} - ${endDate.format("MMM Do")}`;
  } */
}

const hasAnyData = computed(() => {
  return props.nextCalendarGenSummary || props.longTermCalendarGenSummary;
});
</script>

<style scoped lang="scss">
.future-content-needs {
  padding-top: 8px;
}

.future-content-needs__section {
  margin-bottom: 36px;
}

.week-title-divider__subtitle {
  font: 14px / 18px sans-serif;
  color: rgb(91, 91, 91);
}
</style>
